(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[442],{

/***/ 33311:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "DEFAULT_ID": function() { return /* binding */ DEFAULT_ID; },
/* harmony export */   "Loader": function() { return /* binding */ Loader; },
/* harmony export */   "LoaderStatus": function() { return /* binding */ LoaderStatus; }
/* harmony export */ });
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

// do not edit .js files directly - edit src/index.jst



var fastDeepEqual = function equal(a, b) {
  if (a === b) return true;

  if (a && b && typeof a == 'object' && typeof b == 'object') {
    if (a.constructor !== b.constructor) return false;

    var length, i, keys;
    if (Array.isArray(a)) {
      length = a.length;
      if (length != b.length) return false;
      for (i = length; i-- !== 0;)
        if (!equal(a[i], b[i])) return false;
      return true;
    }



    if (a.constructor === RegExp) return a.source === b.source && a.flags === b.flags;
    if (a.valueOf !== Object.prototype.valueOf) return a.valueOf() === b.valueOf();
    if (a.toString !== Object.prototype.toString) return a.toString() === b.toString();

    keys = Object.keys(a);
    length = keys.length;
    if (length !== Object.keys(b).length) return false;

    for (i = length; i-- !== 0;)
      if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;

    for (i = length; i-- !== 0;) {
      var key = keys[i];

      if (!equal(a[key], b[key])) return false;
    }

    return true;
  }

  // true if both NaN, false otherwise
  return a!==a && b!==b;
};

/**
 * Copyright 2019 Google LLC. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at.
 *
 *      Http://www.apache.org/licenses/LICENSE-2.0.
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const DEFAULT_ID = "__googleMapsScriptId";
/**
 * The status of the [[Loader]].
 */
var LoaderStatus;
(function (LoaderStatus) {
    LoaderStatus[LoaderStatus["INITIALIZED"] = 0] = "INITIALIZED";
    LoaderStatus[LoaderStatus["LOADING"] = 1] = "LOADING";
    LoaderStatus[LoaderStatus["SUCCESS"] = 2] = "SUCCESS";
    LoaderStatus[LoaderStatus["FAILURE"] = 3] = "FAILURE";
})(LoaderStatus || (LoaderStatus = {}));
/**
 * [[Loader]] makes it easier to add Google Maps JavaScript API to your application
 * dynamically using
 * [Promises](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Promise).
 * It works by dynamically creating and appending a script node to the the
 * document head and wrapping the callback function so as to return a promise.
 *
 * ```
 * const loader = new Loader({
 *   apiKey: "",
 *   version: "weekly",
 *   libraries: ["places"]
 * });
 *
 * loader.load().then((google) => {
 *   const map = new google.maps.Map(...)
 * })
 * ```
 */
class Loader {
    /**
     * Creates an instance of Loader using [[LoaderOptions]]. No defaults are set
     * using this library, instead the defaults are set by the Google Maps
     * JavaScript API server.
     *
     * ```
     * const loader = Loader({apiKey, version: 'weekly', libraries: ['places']});
     * ```
     */
    constructor({ apiKey, authReferrerPolicy, channel, client, id = DEFAULT_ID, language, libraries = [], mapIds, nonce, region, retries = 3, url = "https://maps.googleapis.com/maps/api/js", version, }) {
        this.callbacks = [];
        this.done = false;
        this.loading = false;
        this.errors = [];
        this.apiKey = apiKey;
        this.authReferrerPolicy = authReferrerPolicy;
        this.channel = channel;
        this.client = client;
        this.id = id || DEFAULT_ID; // Do not allow empty string
        this.language = language;
        this.libraries = libraries;
        this.mapIds = mapIds;
        this.nonce = nonce;
        this.region = region;
        this.retries = retries;
        this.url = url;
        this.version = version;
        if (Loader.instance) {
            if (!fastDeepEqual(this.options, Loader.instance.options)) {
                throw new Error(`Loader must not be called again with different options. ${JSON.stringify(this.options)} !== ${JSON.stringify(Loader.instance.options)}`);
            }
            return Loader.instance;
        }
        Loader.instance = this;
    }
    get options() {
        return {
            version: this.version,
            apiKey: this.apiKey,
            channel: this.channel,
            client: this.client,
            id: this.id,
            libraries: this.libraries,
            language: this.language,
            region: this.region,
            mapIds: this.mapIds,
            nonce: this.nonce,
            url: this.url,
            authReferrerPolicy: this.authReferrerPolicy,
        };
    }
    get status() {
        if (this.errors.length) {
            return LoaderStatus.FAILURE;
        }
        if (this.done) {
            return LoaderStatus.SUCCESS;
        }
        if (this.loading) {
            return LoaderStatus.LOADING;
        }
        return LoaderStatus.INITIALIZED;
    }
    get failed() {
        return this.done && !this.loading && this.errors.length >= this.retries + 1;
    }
    /**
     * CreateUrl returns the Google Maps JavaScript API script url given the [[LoaderOptions]].
     *
     * @ignore
     * @deprecated
     */
    createUrl() {
        let url = this.url;
        url += `?callback=__googleMapsCallback`;
        if (this.apiKey) {
            url += `&key=${this.apiKey}`;
        }
        if (this.channel) {
            url += `&channel=${this.channel}`;
        }
        if (this.client) {
            url += `&client=${this.client}`;
        }
        if (this.libraries.length > 0) {
            url += `&libraries=${this.libraries.join(",")}`;
        }
        if (this.language) {
            url += `&language=${this.language}`;
        }
        if (this.region) {
            url += `&region=${this.region}`;
        }
        if (this.version) {
            url += `&v=${this.version}`;
        }
        if (this.mapIds) {
            url += `&map_ids=${this.mapIds.join(",")}`;
        }
        if (this.authReferrerPolicy) {
            url += `&auth_referrer_policy=${this.authReferrerPolicy}`;
        }
        return url;
    }
    deleteScript() {
        const script = document.getElementById(this.id);
        if (script) {
            script.remove();
        }
    }
    /**
     * Load the Google Maps JavaScript API script and return a Promise.
     * @deprecated, use importLibrary() instead.
     */
    load() {
        return this.loadPromise();
    }
    /**
     * Load the Google Maps JavaScript API script and return a Promise.
     *
     * @ignore
     * @deprecated, use importLibrary() instead.
     */
    loadPromise() {
        return new Promise((resolve, reject) => {
            this.loadCallback((err) => {
                if (!err) {
                    resolve(window.google);
                }
                else {
                    reject(err.error);
                }
            });
        });
    }
    importLibrary(name) {
        this.execute();
        return google.maps.importLibrary(name);
    }
    /**
     * Load the Google Maps JavaScript API script with a callback.
     * @deprecated, use importLibrary() instead.
     */
    loadCallback(fn) {
        this.callbacks.push(fn);
        this.execute();
    }
    /**
     * Set the script on document.
     */
    setScript() {
        var _a, _b;
        if (document.getElementById(this.id)) {
            // TODO wrap onerror callback for cases where the script was loaded elsewhere
            this.callback();
            return;
        }
        const params = {
            key: this.apiKey,
            channel: this.channel,
            client: this.client,
            libraries: this.libraries.length && this.libraries,
            v: this.version,
            mapIds: this.mapIds,
            language: this.language,
            region: this.region,
            authReferrerPolicy: this.authReferrerPolicy,
        };
        // keep the URL minimal:
        Object.keys(params).forEach(
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        (key) => !params[key] && delete params[key]);
        if (!((_b = (_a = window === null || window === void 0 ? void 0 : window.google) === null || _a === void 0 ? void 0 : _a.maps) === null || _b === void 0 ? void 0 : _b.importLibrary)) {
            // tweaked copy of https://developers.google.com/maps/documentation/javascript/load-maps-js-api#dynamic-library-import
            // which also sets the base url, the id, and the nonce
            /* eslint-disable */
            ((g) => {
                // @ts-ignore
                let h, a, k, p = "The Google Maps JavaScript API", c = "google", l = "importLibrary", q = "__ib__", m = document, b = window;
                // @ts-ignore
                b = b[c] || (b[c] = {});
                // @ts-ignore
                const d = b.maps || (b.maps = {}), r = new Set(), e = new URLSearchParams(), u = () => 
                // @ts-ignore
                h || (h = new Promise((f, n) => __awaiter(this, void 0, void 0, function* () {
                    var _a;
                    yield (a = m.createElement("script"));
                    a.id = this.id;
                    e.set("libraries", [...r] + "");
                    // @ts-ignore
                    for (k in g)
                        e.set(k.replace(/[A-Z]/g, (t) => "_" + t[0].toLowerCase()), g[k]);
                    e.set("callback", c + ".maps." + q);
                    a.src = this.url + `?` + e;
                    d[q] = f;
                    a.onerror = () => (h = n(Error(p + " could not load.")));
                    // @ts-ignore
                    a.nonce = this.nonce || ((_a = m.querySelector("script[nonce]")) === null || _a === void 0 ? void 0 : _a.nonce) || "";
                    m.head.append(a);
                })));
                // @ts-ignore
                d[l] ? console.warn(p + " only loads once. Ignoring:", g) : (d[l] = (f, ...n) => r.add(f) && u().then(() => d[l](f, ...n)));
            })(params);
            /* eslint-enable */
        }
        // While most libraries populate the global namespace when loaded via bootstrap params,
        // this is not the case for "marker" when used with the inline bootstrap loader
        // (and maybe others in the future). So ensure there is an importLibrary for each:
        const libraryPromises = this.libraries.map((library) => this.importLibrary(library));
        // ensure at least one library, to kick off loading...
        if (!libraryPromises.length) {
            libraryPromises.push(this.importLibrary("core"));
        }
        Promise.all(libraryPromises).then(() => this.callback(), (error) => {
            const event = new ErrorEvent("error", { error }); // for backwards compat
            this.loadErrorCallback(event);
        });
    }
    /**
     * Reset the loader state.
     */
    reset() {
        this.deleteScript();
        this.done = false;
        this.loading = false;
        this.errors = [];
        this.onerrorEvent = null;
    }
    resetIfRetryingFailed() {
        if (this.failed) {
            this.reset();
        }
    }
    loadErrorCallback(e) {
        this.errors.push(e);
        if (this.errors.length <= this.retries) {
            const delay = this.errors.length * Math.pow(2, this.errors.length);
            console.error(`Failed to load Google Maps script, retrying in ${delay} ms.`);
            setTimeout(() => {
                this.deleteScript();
                this.setScript();
            }, delay);
        }
        else {
            this.onerrorEvent = e;
            this.callback();
        }
    }
    callback() {
        this.done = true;
        this.loading = false;
        this.callbacks.forEach((cb) => {
            cb(this.onerrorEvent);
        });
        this.callbacks = [];
    }
    execute() {
        this.resetIfRetryingFailed();
        if (this.done) {
            this.callback();
        }
        else {
            // short circuit and warn if google.maps is already loaded
            if (window.google && window.google.maps && window.google.maps.version) {
                console.warn("Google Maps already loaded outside @googlemaps/js-api-loader." +
                    "This may result in undesirable behavior as options and script parameters may not match.");
                this.callback();
                return;
            }
            if (this.loading) ;
            else {
                this.loading = true;
                this.setScript();
            }
        }
    }
}


//# sourceMappingURL=index.esm.js.map


/***/ }),

/***/ 37212:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

(function (global, factory) {
     true ? factory(exports, __webpack_require__(33311), __webpack_require__(67294)) :
    0;
})(this, (function (exports, jsApiLoader, React) { 'use strict';

    function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

    var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

    /**
     * Copyright 2021 Google LLC. All Rights Reserved.
     *
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at.
     *
     *      Http://www.apache.org/licenses/LICENSE-2.0.
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     */
    exports.Status = void 0;
    (function (Status) {
        Status["LOADING"] = "LOADING";
        Status["FAILURE"] = "FAILURE";
        Status["SUCCESS"] = "SUCCESS";
    })(exports.Status || (exports.Status = {}));
    /**
     * A component to wrap the loading of the Google Maps JavaScript API.
     *
     * ```
     * import { Wrapper } from '@googlemaps/react-wrapper';
     *
     * const MyApp = () => (
     * 	<Wrapper apiKey={'YOUR_API_KEY'}>
     * 		<MyMapComponent />
     * 	</Wrapper>
     * );
     * ```
     *
     * @param props
     */
    const Wrapper = ({ children, render, callback, ...options }) => {
        const [status, setStatus] = React.useState(exports.Status.LOADING);
        React.useEffect(() => {
            const loader = new jsApiLoader.Loader(options);
            const setStatusAndExecuteCallback = (status) => {
                if (callback)
                    callback(status, loader);
                setStatus(status);
            };
            setStatusAndExecuteCallback(exports.Status.LOADING);
            loader.load().then(() => setStatusAndExecuteCallback(exports.Status.SUCCESS), () => setStatusAndExecuteCallback(exports.Status.FAILURE));
        }, []);
        if (status === exports.Status.SUCCESS && children)
            return React__default["default"].createElement(React__default["default"].Fragment, null, children);
        if (render)
            return render(status);
        return React__default["default"].createElement(React__default["default"].Fragment, null);
    };

    exports.Wrapper = Wrapper;

    Object.defineProperty(exports, '__esModule', { value: true });

}));


/***/ }),

/***/ 5695:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/store-locator",
      function () {
        return __webpack_require__(55494);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 55494:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _urbanpiper_engineering_meraki_sdk__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(63228);
/* harmony import */ var react_i18next__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(26793);
/* harmony import */ var _googlemaps_react_wrapper__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(37212);
/* harmony import */ var _googlemaps_react_wrapper__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_googlemaps_react_wrapper__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _urbanpiper_engineering_meraki_components__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(65460);
/* harmony import */ var _urbanpiper_engineering_meraki_components_dist_Molecules_Confirm__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(68494);
/* harmony import */ var _urbanpiper_engineering_meraki_components_dist_Molecules_Alert__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(62350);
/* harmony import */ var _stores_module_scss__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(65895);
/* harmony import */ var _stores_module_scss__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(_stores_module_scss__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _ant_design_icons__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(97937);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_8__);












function StoresPage(param) {
    let { mapKey , seoConfig , primaryColor , businessInfo  } = param;
    var _storeList_, _storeList_1, _storeList_2, _storeList_3;
    const { t  } = (0,react_i18next__WEBPACK_IMPORTED_MODULE_9__/* .useTranslation */ .$)();
    const router = (0,next_router__WEBPACK_IMPORTED_MODULE_7__.useRouter)();
    const [storeList, setStoreList] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)([]);
    const useStoreState = _urbanpiper_engineering_meraki_sdk__WEBPACK_IMPORTED_MODULE_2__/* ["default"].getStoreState */ .ZP.getStoreState().hook();
    const confirmDialog = (0,_urbanpiper_engineering_meraki_components_dist_Molecules_Confirm__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)();
    const alertDialog = (0,_urbanpiper_engineering_meraki_components_dist_Molecules_Alert__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)();
    const selectedStore = useStoreState((state)=>state.selectedStore);
    const [isStoreDrawerVisible, setIsStoreDrawerVisible] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    const [filteredListMobile, setFilteredListMobile] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)([]);
    const [filteredListWeb, setFilteredListWeb] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(storeList);
    const searchRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        (async ()=>{
            const stores = await _urbanpiper_engineering_meraki_sdk__WEBPACK_IMPORTED_MODULE_2__/* ["default"].getStores */ .ZP.getStores();
            const storesEnabledForOrdering = stores === null || stores === void 0 ? void 0 : stores.filter((store)=>{
                return store === null || store === void 0 ? void 0 : store.enabled_for_ordering;
            });
            setStoreList(storesEnabledForOrdering);
            setFilteredListWeb(storesEnabledForOrdering);
        })();
    }, []);
    const handleSearchStore = async (searchTerm)=>{
        if (searchTerm !== "") {
            const filteredList = await _urbanpiper_engineering_meraki_sdk__WEBPACK_IMPORTED_MODULE_2__/* ["default"].searchStore */ .ZP.searchStore(storeList, searchTerm);
            setFilteredListMobile(filteredList);
            setFilteredListWeb(filteredList);
            if (searchRef && searchRef.current) {
                searchRef.current.scrollIntoView();
            }
        }
    };
    const handleSelectStoreError = (err)=>{
        if (err.message === _urbanpiper_engineering_meraki_sdk__WEBPACK_IMPORTED_MODULE_2__/* .Exceptions.STORE_ORDERING_NOT_ENABLED */ .XM.STORE_ORDERING_NOT_ENABLED) {
            alertDialog({
                title: t("storeLocator.storeClosed"),
                content: (businessInfo === null || businessInfo === void 0 ? void 0 : businessInfo.msg_nearest_store_closed) || t("storeLocator.storeClosed")
            });
        }
        if (err.message === _urbanpiper_engineering_meraki_sdk__WEBPACK_IMPORTED_MODULE_2__/* .Exceptions.STORE_TEMPORARY_CLOSED */ .XM.STORE_TEMPORARY_CLOSED) {
            alertDialog({
                title: t("storeLocator.storeClosed"),
                content: (businessInfo === null || businessInfo === void 0 ? void 0 : businessInfo.msg_nearest_store_closed) || t("storeLocator.storeClosed")
            });
        }
    };
    const handleSelectStore = (storeId)=>{
        const selectedStore = storeList.find((s)=>s.id === storeId);
        if (selectedStore) {
            const storeContent = {
                id: storeId,
                address: selectedStore.address,
                latitude: selectedStore.lat,
                longitude: selectedStore.lng,
                storeInfo: selectedStore,
                ffMode: "pickup"
            };
            try {
                _urbanpiper_engineering_meraki_sdk__WEBPACK_IMPORTED_MODULE_2__/* ["default"].setSelectedStore */ .ZP.setSelectedStore(storeContent);
                router.push("/menu");
            } catch (err) {
                if (err.message === _urbanpiper_engineering_meraki_sdk__WEBPACK_IMPORTED_MODULE_2__/* .Exceptions.CART_ALREADY_EXISTS */ .XM.CART_ALREADY_EXISTS) {
                    confirmDialog({
                        title: t("header.clearCartHeading"),
                        content: t("header.clearCartDescription"),
                        onConfirm: ()=>{
                            try {
                                _urbanpiper_engineering_meraki_sdk__WEBPACK_IMPORTED_MODULE_2__/* ["default"].setSelectedStore */ .ZP.setSelectedStore(storeContent, true);
                                router.push("/menu");
                            } catch (err) {
                                handleSelectStoreError(err);
                            }
                        }
                    });
                }
                handleSelectStoreError(err);
            }
        }
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: (_stores_module_scss__WEBPACK_IMPORTED_MODULE_10___default().parent),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_8___default()), {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                        children: seoConfig.title
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "description",
                        content: seoConfig.description
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "keywords",
                        content: seoConfig.keywords
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "container ".concat((_stores_module_scss__WEBPACK_IMPORTED_MODULE_10___default().web_container)),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: (_stores_module_scss__WEBPACK_IMPORTED_MODULE_10___default().map_main),
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_googlemaps_react_wrapper__WEBPACK_IMPORTED_MODULE_3__.Wrapper, {
                            apiKey: mapKey,
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_urbanpiper_engineering_meraki_components__WEBPACK_IMPORTED_MODULE_4__/* .GoogleMap */ .b6, {
                                className: (_stores_module_scss__WEBPACK_IMPORTED_MODULE_10___default().map),
                                center: {
                                    lat: (selectedStore === null || selectedStore === void 0 ? void 0 : selectedStore.latitude) || (storeList === null || storeList === void 0 ? void 0 : (_storeList_ = storeList[0]) === null || _storeList_ === void 0 ? void 0 : _storeList_.latitude),
                                    lng: (selectedStore === null || selectedStore === void 0 ? void 0 : selectedStore.longitude) || (storeList === null || storeList === void 0 ? void 0 : (_storeList_1 = storeList[0]) === null || _storeList_1 === void 0 ? void 0 : _storeList_1.longitude)
                                },
                                zoom: 13,
                                markers: storeList.map((store)=>({
                                        lat: store.lat,
                                        lng: store.lng,
                                        label: store.name,
                                        color: primaryColor
                                    }))
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: (_stores_module_scss__WEBPACK_IMPORTED_MODULE_10___default().stores),
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_urbanpiper_engineering_meraki_components__WEBPACK_IMPORTED_MODULE_4__/* .Typography */ .ZT, {
                                variant: "headingOne",
                                classes: (_stores_module_scss__WEBPACK_IMPORTED_MODULE_10___default().typo),
                                children: t("storeLocator.sectionHeading")
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_urbanpiper_engineering_meraki_components__WEBPACK_IMPORTED_MODULE_4__/* .StoreLocatorList */ .Ie, {
                                classes: (_stores_module_scss__WEBPACK_IMPORTED_MODULE_10___default().web_store_list),
                                stores: filteredListWeb,
                                searchStore: handleSearchStore,
                                selectStore: (storeId)=>handleSelectStore(storeId)
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: (_stores_module_scss__WEBPACK_IMPORTED_MODULE_10___default().mobile_container),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_googlemaps_react_wrapper__WEBPACK_IMPORTED_MODULE_3__.Wrapper, {
                        apiKey: mapKey,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_urbanpiper_engineering_meraki_components__WEBPACK_IMPORTED_MODULE_4__/* .GoogleMap */ .b6, {
                            className: (_stores_module_scss__WEBPACK_IMPORTED_MODULE_10___default().mobile_map),
                            center: {
                                lat: (selectedStore === null || selectedStore === void 0 ? void 0 : selectedStore.latitude) || (storeList === null || storeList === void 0 ? void 0 : (_storeList_2 = storeList[0]) === null || _storeList_2 === void 0 ? void 0 : _storeList_2.latitude),
                                lng: (selectedStore === null || selectedStore === void 0 ? void 0 : selectedStore.longitude) || (storeList === null || storeList === void 0 ? void 0 : (_storeList_3 = storeList[0]) === null || _storeList_3 === void 0 ? void 0 : _storeList_3.longitude)
                            },
                            zoom: 13,
                            markers: storeList.map((store)=>({
                                    lat: store.lat,
                                    lng: store.lng,
                                    label: store.name,
                                    color: primaryColor
                                }))
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        ref: searchRef,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_urbanpiper_engineering_meraki_components__WEBPACK_IMPORTED_MODULE_4__/* .StoreLocatorSearch */ .fr, {
                            searchStore: handleSearchStore,
                            selectStore: (storeId)=>handleSelectStore(storeId),
                            defaultSuggestion: storeList === null || storeList === void 0 ? void 0 : storeList[0],
                            stores: filteredListMobile
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_urbanpiper_engineering_meraki_components__WEBPACK_IMPORTED_MODULE_4__/* .Drawer */ .dy, {
                classes: (_stores_module_scss__WEBPACK_IMPORTED_MODULE_10___default().mobile_stores_drawer),
                open: isStoreDrawerVisible,
                direction: "right",
                onClose: ()=>setIsStoreDrawerVisible(false),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: (_stores_module_scss__WEBPACK_IMPORTED_MODULE_10___default().mobile_stores_drawer_header),
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_urbanpiper_engineering_meraki_components__WEBPACK_IMPORTED_MODULE_4__/* .Typography */ .ZT, {
                                variant: "headingTwo",
                                classes: (_stores_module_scss__WEBPACK_IMPORTED_MODULE_10___default().mobile_stores_drawer_header_title),
                                children: t("storeLocator.sectionHeading")
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_ant_design_icons__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                                onClick: ()=>setIsStoreDrawerVisible(false)
                            })
                        ]
                    }),
                    storeList.map((store)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_urbanpiper_engineering_meraki_components__WEBPACK_IMPORTED_MODULE_4__/* .StoreLocatorCardMobile */ .dO, {
                                    ...store,
                                    selectStore: ()=>{
                                        _urbanpiper_engineering_meraki_sdk__WEBPACK_IMPORTED_MODULE_2__/* ["default"].setSelectedStore */ .ZP.setSelectedStore({
                                            id: store.id,
                                            address: store.address,
                                            latitude: store.lat,
                                            longitude: store.lng,
                                            ffMode: "pickup"
                                        }, true);
                                        router.push("/menu");
                                    }
                                }, store.id),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_urbanpiper_engineering_meraki_components__WEBPACK_IMPORTED_MODULE_4__/* .Divider */ .iz, {
                                    dividerStyle: "solid",
                                    variant: "horizontal",
                                    size: "100%"
                                })
                            ]
                        }, store.id))
                ]
            })
        ]
    });
}
var __N_SSP = true;
/* harmony default export */ __webpack_exports__["default"] = (StoresPage);


/***/ }),

/***/ 65895:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"web_container":"stores_web_container__D2Yqy","map_main":"stores_map_main__LfUlj","map":"stores_map__K9smT","stores":"stores_stores__bFO9Z","typo":"stores_typo__8MTzB","web_store_list":"stores_web_store_list__6Drh4","mobile_container":"stores_mobile_container__9o0jF","mobile_stores_drawer":"stores_mobile_stores_drawer__4dtwq","mobile_map":"stores_mobile_map__HYYAw","mobile_stores_drawer_header":"stores_mobile_stores_drawer_header__eAmkg","mobile_stores_drawer_header_title":"stores_mobile_stores_drawer_header_title__yJ3CP"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [2778,3791,5390,9355,1620,8862,223,5306,2508,9281,145,2806,1112,2149,8809,5570,5460,7937,9774,2888,179], function() { return __webpack_exec__(5695); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);